var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReceipt = function SvgReceipt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-46 40)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M66-36v15.5l-2.173-1.63a3.018,3.018,0,0,0-1.8-.6,3.01,3.01,0,0,0-1.9.683L58-20.3l-2.123-1.745a3.01,3.01,0,0,0-1.9-.683,3.018,3.018,0,0,0-1.8.6L50-20.5V-36H66m0-2H50a2,2,0,0,0-2,2v16a2,2,0,0,0,1.484,1.933.933.933,0,0,0,.234.03,1.02,1.02,0,0,0,.607-.207l3.047-2.285a1,1,0,0,1,.6-.2,1,1,0,0,1,.635.228l2.5,2.054a1.994,1.994,0,0,0,.894.211,1.994,1.994,0,0,0,.894-.211l2.5-2.054a1,1,0,0,1,.635-.228,1,1,0,0,1,.6.2l3.047,2.285a1.02,1.02,0,0,0,.607.207.933.933,0,0,0,.234-.03A2,2,0,0,0,68-20V-36a2,2,0,0,0-2-2Zm-7,6a1,1,0,0,0-1-1H53a1,1,0,0,0-1,1,1,1,0,0,0,1,1h5A1,1,0,0,0,59-32Zm-2,4a1,1,0,0,0-1-1H53a1,1,0,0,0-1,1,1,1,0,0,0,1,1h3A1,1,0,0,0,57-28Zm7-4a1,1,0,0,0-1-1H61a1,1,0,0,0-1,1,1,1,0,0,0,1,1h2A1,1,0,0,0,64-32Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReceipt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/receipt.487341b5.svg";
export { ForwardRef as ReactComponent };